import config from 'build-and-quote/config/index.js';
import PropTypes from 'prop-types';
import React from 'react';

import { IMAGES_BASE_PATH, ACCESSORY_DESCRIPTION_MAX_LENGTH } from 'build-and-quote/constants/accessoryImage.js';
import { ModelYear } from '@sm360/widget-commons-vehicle';
import { UrlService } from '@sm360/widget-commons-core-services';

class AccessoryImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { imageNotFound: !props.option.imageUrl };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.option.imageUrl !== this.props.option.imageUrl) {
            this.setState({ imageNotFound: !newProps.option.imageUrl });
        }
    }

    render() {
        const imagesServer = config.source.image;
        const imgUrl =
            this.props?.option?.imageUrl && UrlService.isValidHttpUrl(this.props.option.imageUrl)
                ? this.props.option.imageUrl
                : `${imagesServer}${IMAGES_BASE_PATH}/${this.props.option.imageUrl}`;

        const image = !this.state.imageNotFound && (
            <img
                src={imgUrl}
                alt={this.props.option.description}
                className="accessoryImage"
                onError={() => this.setState({ imageNotFound: true })}
            />
        );
        const classNames = ['accessory_wrapper--image', 'has-primary-background'];
        if (this.state.imageNotFound) {
            classNames.push('no-image');
        }

        return (
            <div className={classNames.join(' ')}>
                {this.props.option.description.length > ACCESSORY_DESCRIPTION_MAX_LENGTH && (
                    <button onClick={this.props.showAccessoryDetails} className="icon-info-button">
                        <p>i</p>
                    </button>
                )}
                {image || <icon className="icon-showroom icon-camera-off" />}
            </div>
        );
    }
}

AccessoryImage.propTypes = {
    option: PropTypes.instanceOf(ModelYear.OptionModel).isRequired,
    showAccessoryDetails: PropTypes.func.isRequired,
};

AccessoryImage.displayName = 'AccessoryImage';

export default AccessoryImage;
